import Link from 'next/link';
import React from 'react';
import { DoneIcon } from '../icons';
import { TStep } from '../steps';

interface SidebarApplicationItemProps {
  step: TStep;
  currentStepId: string;
}

export default function SidebarApplicationItem({
  step,
  currentStepId: _currentStepId,
}: SidebarApplicationItemProps) {
  const stepId = Number(step.id);
  const currentStepId = Number(_currentStepId);
  return (
    <div className="w-full flex flex-row flex-wrap">
      {stepId < currentStepId ? (
        <div className="w-6 h-6 rounded-full bg-cyan flex">
          <DoneIcon className="w-4 h-4 text-dark-blue m-auto" />
        </div>
      ) : (
        <div className="w-6 h-6 rounded-full border border-white flex">
          <p className="m-auto font-bold text-[10px] text-white">{step.id}</p>
        </div>
      )}
      <div className="flex-1 ml-3">
        <Link
          href="/request-scholarship/[...id]"
          as={`/request-scholarship/${step.id}`}
          className="font-bold text-white"
        >
          {step.name}
        </Link>
      </div>
    </div>
  );
}
